import { IQRANavUtilsConsumerComponentInitProps } from 'common/utils/navigation/qraNavUtils'

/**
 * Match string with mock `graphType`
 */
export enum QRAGraphType {
  THREATS = 'riskbythreat',
  CONSEQUENCES = 'riskbyconsequence',
  RISK_BY_LINE = 'riskbyline',
  LINEAR_REFERENCE = 'riskbylinearreference',
  RISK_FORECAST = 'riskforecast',
  RISK_BY_SIGNIFICANCE_LEVEL = 'riskbysignificancelevel',
  RISK_LEVEL_BY_OUTCOME_SCENARIO = 'riskbyoutcomescenario',
  RISK_BY_RELEASE_TYPE = 'riskbyreleasetype',
  RISK_BY_SYSTEM = 'riskbysystem',
  RISK_BY_CONSEQUENCE_AREAS = 'riskbyconsequenceareas'
}

export enum CommonChartStateName {
  BASELINE = 'baseline',
  WIS = 'wis',
  TIME_DEPENDENT = 'time_dependent',
  RESIDENT = 'resident',
  TIME_INDEPENDENT = 'time_independent'
}

// For use by component that that generates the required data for `IGraphsViewProps`
export interface IGraphsViewBaseProps
  extends IQRANavUtilsConsumerComponentInitProps {}

export interface ISystemGraphsViewProps extends IGraphsViewBaseProps {
  showLoading: boolean
  charts?: IQRAChartObjects
  hasLineViewNavigation: boolean
  itemsFromGraphType?: Record<string, () => QRAChartItems[] | undefined>
}

export interface ILineGraphsViewProps extends IGraphsViewBaseProps {
  showLoading: boolean
  charts?: IQRAChartObjects
}

export interface IQRAGraphQueryParams {
  systemScopeId?: string
  baselineId1?: string
  baselineId2?: string
  assessmentId?: string
  continuousRouteId?: string
}

export interface IQRAGraphBools {
  [QRAGraphType.THREATS]?: boolean
  [QRAGraphType.CONSEQUENCES]?: boolean
  [QRAGraphType.RISK_BY_LINE]?: boolean
  [QRAGraphType.RISK_FORECAST]?: boolean
  [QRAGraphType.LINEAR_REFERENCE]?: boolean
  [QRAGraphType.RISK_BY_SIGNIFICANCE_LEVEL]?: boolean
  [QRAGraphType.RISK_LEVEL_BY_OUTCOME_SCENARIO]?: boolean
  [QRAGraphType.RISK_BY_RELEASE_TYPE]?: boolean
  [QRAGraphType.RISK_BY_SYSTEM]?: boolean
  [QRAGraphType.RISK_BY_CONSEQUENCE_AREAS]?: boolean
}

export interface IChartData {
  categoryIds: number[]
  categories: string[]
  values: IChartDataValues
  labels: IChartSeriesLabels
}

export interface IChartDataValues {
  // May contain `CommonChartStateName`s
  [stateName: string]: number[]
}

export interface IChartSeriesLabels {
  [label: string]: string
}

// REVIEW: Promote this into main @type?
// Based on structure from API
export interface IQRAChartObjects {
  [chart: string]: IQRAChartBaseObject | undefined
}

export interface IQRAChartBaseObject {
  graphType: QRAGraphType
}

export type QRAChartItems =
  | QRARiskForecastChartItems
  | QRAStandardChartItems
  | QRALinearReferenceChartItems

type QRAStandardChartItems = {
  id: number
  name: string
  values: Array<{
    key: string
    value: number
  }>
}

export interface IQRAStandardChartObject extends IQRAChartBaseObject {
  items: Array<QRAStandardChartItems>
}

export type QRARiskForecastChartItems = {
  year: number
  items: Array<{
    name: string
    values: Array<{
      key: string
      value: number
    }>
  }>
}

export interface IQRARiskForecastChartObject extends IQRAChartBaseObject {
  items: Array<QRARiskForecastChartItems>
}

type QRALinearReferenceChartItems = {
  id: number
  values: [
    {
      key: string
      value: {
        fromMeasure: number
        toMeasure: number
        risk: number
      }
    }
  ]
}

export interface IQRALinearReferenceChartObject extends IQRAChartBaseObject {
  acceptanceCategories: [
    {
      id: number
      minValue: number
      maxValue: number
      code: string
    }
  ]
  items: QRALinearReferenceChartItems[]
}
